import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewAppContent from './viewRelatedAppContents';

export default {
  attributeName: 'sidePanels',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have side panels, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'placement',
      label: 'Placement',
      type: FormInputTypes.SELECT,
      helpText: 'Placement of the side panel.',
      options: [
        { value: 'right', name: 'Right' },
        { value: 'left', name: 'Left' },
      ],
      canEdit: true,
      canCreate: true,
      width: '12rem',
      default: 'right',
    },
    {
      attributeName: 'enable',
      label: 'Show',
      helpText: 'Whether or not the side panel is enable.',
      type: FormInputTypes.CHECKBOX,
      default: true,
      canEdit: true,
      canCreate: true,
      width: '4rem',
    },
    {
      attributeName: 'content',
      label: 'Content',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewAppContent,
      default: {},      
      width: '12rem',
      helpText: 'Select the content to show on the side panel',
    },
    {
      attributeName: 'appFeatureImageId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Large Poster (588x380)',
      helpText: 'Image to upload for the featured content.',
      placeholder: 'Featured content image', 
      canEdit: true,
      canCreate: true,
      hasSelect:false,
      width: '4rem',
      fileType: ['image/*'],
    },
    {
      attributeName: 'appFeatureImageIdTablet',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Tablet Portrait (1176x760)',
      helpText: 'Image to upload for the featured content. Tablet portrait size.',
      placeholder: 'Featured content image',      
      canEdit: true,
      canCreate: true,
      hasSelect:false,
      width: '4rem',
      fileType: ['image/*'],
    },
    {
      attributeName: 'appFeatureImageIdTabletLandscape',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Tablet Landscape (1432x760)',
      helpText: 'Image to upload for the featured content. Tablet landscape size.',
      placeholder: 'Featured content image',   
      canEdit: true,
      canCreate: true,
      hasSelect:false,
      width: '4rem',
      fileType: ['image/*'],
    },
    {
      attributeName: 'featureUrl',
      label: 'Feature Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Url for the content image.',
      canEdit: true,
      canCreate: true,
      width: '12rem',

    },
  ],
};
